import { isArray, isUndefined } from 'lodash';

export const getFieldKey = (field) =>
  (field.fieldType || 'custom') +
  (field.customField?.id || field.customFieldEntityId || field.customFieldId || '');
export const requiredFieldList = [];
export const systemFieldList = ['real_name'];
export const defaultTypeFields = ['edition'];
export const systemTypeKeyMap = {
  type: 'requirementType',
  file: 'fileIdList',
  report: 'reportList',
  purpose: 'description',
};

export const fieldNameMap = {
  real_name: '真实姓名',
};

export const getFieldName = (field) => {
  if (field.fieldType !== 'custom') {
    return fieldNameMap[field.fieldType] || '';
  }
  return field.customField?.name || '';
};

export const getFieldWidgetType = (field) => {
  const { fieldType, customField } = field;
  if (['name', 'scene', 'question', 'goal', 'id'].includes(fieldType)) {
    return 'text';
  }
  if (['purpose', 'note', 'description'].includes(fieldType)) {
    return 'textarea';
  }
  if (
    ['expectCompleteTime', 'handleStartTime', 'handleEndTime', 'createdAt', 'finishTime'].includes(
      fieldType,
    )
  ) {
    return 'date';
  }
  if (['reporter', 'handler'].includes(fieldType)) {
    return 'member';
  }
  if (['priority', 'progress'].includes(fieldType)) {
    return 'number';
  }

  if (customField) {
    return customField.widgetType;
  }
  // 其他复杂类型
  return fieldType;
};
export const sortableTypes = ['date', 'number'];

export const selectTypes = ['SELECT', 'MULTIPLE_SELECT'];

export const cascadeTypes = ['cascade', 'multiple_cascade'];

export const multipleValueTypes = ['MULTIPLE_SELECT', 'checkbox', 'multiple_cascade'];

export const nameValueTypes = [
  'TEXT',
  'SELECT',
  'MULTIPLE_SELECT',
  'radio',
  'checkbox',
  'date',
  'progress',
];

export const wrapFieldValue = (value, widgetType, multipleTypes, nameTypes) => {
  if (!widgetType) {
    return value;
  }
  if (!value) {
    return value;
  }
  const isMultiple = (multipleTypes || multipleValueTypes).includes(widgetType);

  if (!isMultiple && isArray(value)) {
    value = value[0];
  }
  if (!value) {
    return value;
  }
  if ((nameTypes || nameValueTypes).includes(widgetType)) {
    return isMultiple ? value.map(({ name }) => name) : value.name;
  }
  return value;
};

export const parseProgress = (value, emptyStr = '') => {
  const wrapValue = wrapProgress(parseInt(value));
  if (!isUndefined(wrapValue)) {
    return `${wrapValue}%`;
  }

  return emptyStr;
};

export const wrapProgress = (value) => {
  if (value === 0) {
    return 0;
  }
  if (value > 0) {
    if (value % 100 === 0) {
      return value / 100;
    } else {
      return (value / 100).toFixed(1);
    }
  }

  return undefined;
};

export const formatProgress = (value) => {
  const num = parseFloat(value);
  if (num >= 0) {
    return Math.round(num * 100);
  }

  return undefined;
};

export const customTypeNameMap = {
  TEXT: '单行文本',
  SELECT: '下拉单选框',
  MULTIPLE_SELECT: '下拉多选框',
};
